import { Stack, Typography } from '@mui/material';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import { useTranslation } from 'react-i18next';

/**
 * Inline rating row for the provider page / booking page header.
 * Renders only when the provider already has at least one review — when
 * a shop is brand-new (count === 0) we return null so visitors see a
 * clean header instead of a discouraging "no ratings yet" state. The
 * provider asked for this: showing an empty placeholder hurts conversion
 * on shops that are still building up social proof.
 */
type Props = {
  score?: number | null;
  count?: number | null;
};

export function ProviderInlineRating({ score = null, count = null }: Props) {
  const { t } = useTranslation();
  const hasData = score != null && count != null && count > 0;
  if (!hasData) return null;

  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      <StarRoundedIcon sx={{ fontSize: '1.05rem', color: 'text.primary' }} />
      <Typography
        variant="body2"
        sx={{ color: 'text.primary', fontWeight: 700 }}
      >
        {score!.toFixed(1)}
      </Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        ({t('reviews.reviewCount', { count: count! })})
      </Typography>
    </Stack>
  );
}
